export default "__VITE_ASSET__f821ad2a__"